export default function Footer() {
  const navGroups = [
    {
      title: '快速导航',
      links: [
        { label: '热播榜单', href: '#ranking' },
        { label: '剧集索引', href: '#index' },
        { label: '精选专题', href: '#carousel' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '特色服务',
      links: [
        { label: '平台特色', href: '#features' },
        { label: '精彩片花', href: '#media' },
        { label: '最新动态', href: '#updates' },
        { label: 'APP下载', href: '#app' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '关于小草影院', href: '#about' },
        { label: '联系投稿', href: '#contact' },
        { label: '热门话题', href: '#topics' },
        { label: '用户口碑', href: '#comments' },
      ],
    },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-800 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <span className="text-2xl font-heading font-black text-primary-400">
                小草影院
              </span>
              <p className="text-sm text-white/55 mt-3 leading-relaxed max-w-xs">
                小草影院提供最新电视剧高清全集在线观看，热播剧集每日更新，无需缓冲流畅追剧。涵盖小草影视热门电视剧、全集视频，高清画质即点即看。
              </p>
            </div>

            {/* Nav groups */}
            {navGroups.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-white/80 mb-3">{group.title}</h4>
                <ul className="space-y-2">
                  {group.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                        className="text-sm text-white/45 hover:text-primary-300 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Partners */}
          <div className="mt-12 pt-8 border-t border-white/10">
            <h4 className="text-sm font-semibold text-white/50 mb-4">合作伙伴</h4>
            <div className="flex flex-wrap items-center gap-4">
              <span className="text-xs text-white/25">优质影视内容合作平台持续接入中</span>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/35">
              &copy; {new Date().getFullYear()} 小草影院 — 所有内容仅供学习交流，版权归原作者所有
            </p>
            <p className="text-xs text-white/25">
              小草影院最新电视剧高清全集在线观看 · 不缓冲追剧体验
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}